<template>
    <!-- <div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view/>
    </div>-->
    <div
        class="page-template-default page page-id-150 wp-custom-logo wp-embed-responsive sek-hide-rc-badge czr-link-hover-underline header-skin-light footer-skin-dark czr-no-sidebar tc-center-images czr-full-layout czr-sticky-footer dojo-hide-title"
    >
        <div id="tc-page-wrap" class>
            <header
                class="tpnav-header__header tc-header sl-logo_left sticky-brand-shrink-on sticky-transparent border-top czr-submenu-fade czr-submenu-move"
                role="banner"
            >
                <div
                    class="primary-navbar__wrapper d-none d-lg-block has-horizontal-menu has-branding-aside"
                >
                    <div class="container">
                        <div class="row align-items-center flex-row primary-navbar__row">
                            <div class="branding__container col col-auto">
                                <div class="branding align-items-center flex-column">
                                    <div
                                        class="branding-row d-flex align-self-start flex-row align-items-center"
                                    >
                                        <div class="navbar-brand col-auto">
                                            <a style="text-decaration"
                                                class="navbar-brand-sitelogo"
                                                href="/"
                                                aria-label="Wersa | South African National Location system"
                                            >
                                                <img
                                                    src="/images/playstore-icon.png"
                                                    alt="Back home"
                                                    class
                                                    width="512"
                                                    height="512"
                                                    style="max-width:250px;max-height:100px"
                                                    data-no-retina
                                                />
                                            </a>
                                        </div>
                                        <div class="branding-aside col-auto flex-column d-flex">
                                            <h1 class="navbar-brand col-auto">
                                                <a
                                                    class="navbar-brand-sitename czr-underline"
                                                    href="/"
                                                >
                                                    <span>Wersa</span>
                                                </a>
                                            </h1>

                                            <span
                                                class="header-tagline"
                                            >South African National Location system</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="primary-nav__container justify-content-lg-around col col-lg-auto flex-lg-column"
                            >
                                <div
                                    class="primary-nav__wrapper flex-lg-row align-items-center justify-content-end"
                                >
                                    <nav class="primary-nav__nav col" id="primary-nav">
                                        <div
                                            class="nav__menu-wrapper primary-nav__menu-wrapper justify-content-end czr-open-on-hover"
                                        >
                                            <ul
                                                id="main-menu"
                                                class="primary-nav__menu regular-nav nav__menu nav"
                                            >
                                                <li
                                                    id="menu-item-114"
                                                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-home menu-item-114"
                                                >
                                                    <router-link to="/" class="nav__link">
                                                      <span class="nav__title">Home</span>
                                                    </router-link>
                                                    <!-- <a
                                                        href="http://wersa.co.za/"
                                                        class="nav__link"
                                                    >
                                                    
                                                        <span class="nav__title">Home</span>
                                                    </a> -->
                                                </li>
                                                <li
                                                    id="menu-item-112"
                                                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-112"
                                                >
                                                    <router-link to="/app" class="nav__link">
                                                      <span class="nav__title">Our App</span>
                                                    </router-link>
                                                    <!-- <a
                                                        href="http://wersa.co.za/app/"
                                                        class="nav__link"
                                                    >
                                                        <span class="nav__title">Our App</span>
                                                    </a> -->
                                                </li>
                                            </ul>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mobile-navbar__wrapper d-lg-none mobile-sticky">
                    <div
                        class="branding__container justify-content-between align-items-center container"
                    >
                        <div class="branding flex-column">
                            <div
                                class="branding-row d-flex align-self-start flex-row align-items-center"
                            >
                                <div class="navbar-brand col-auto">
                                    <a
                                        class="navbar-brand-sitelogo"
                                        href="/"
                                        aria-label="Wersa | South African National Location system"
                                    >
                                        <img
                                            src="/images/playstore-icon.png"
                                            alt="Back home"
                                            class
                                            width="512"
                                            height="512"
                                            style="max-width:250px;max-height:100px"
                                            data-no-retina
                                        />
                                    </a>
                                </div>
                                <div class="branding-aside col-auto">
                                    <h1 class="navbar-brand col-auto">
                                        <a
                                            class="navbar-brand-sitename czr-underline"
                                            href="/"
                                        >
                                            <span>Wersa</span>
                                        </a>
                                    </h1>
                                </div>
                            </div>
                            <span
                                class="header-tagline col col-auto"
                            >South African National Location system</span>
                        </div>
                        <div class="mobile-utils__wrapper nav__utils regular-nav">
                            <ul class="nav utils row flex-row flex-nowrap">
                                <li class="hamburger-toggler__container">
                                    <a
                                        href="#"
                                        v-on:click="showmenu = !showmenu"
                                        class="ham-toggler-menu"
                                        data-toggle="czr-collapse"
                                        data-target="#mobile-nav"
                                        v-bind:class="{ 'czr-collapsed':!showmenu }"
                                    >
                                        <div class="ham__toggler-span-wrapper">
                                            <span class="line line-1"></span>
                                            <span class="line line-2"></span>
                                            <span class="line line-3"></span>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="mobile-nav__container">
                        <nav v-if="showmenu" class="mobile-nav__nav flex-column" id="mobile-nav">
                            <div class="mobile-nav__inner container">
                                <div
                                    class="nav__menu-wrapper mobile-nav__menu-wrapper czr-open-on-click"
                                >
                                    <ul
                                        id="mobile-nav-menu"
                                        class="mobile-nav__menu vertical-nav nav__menu flex-column nav"
                                    >
                                        <li
                                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-home menu-item-114"
                                        >
                                            <a href="/" class="nav__link">
                                                <span class="nav__title">Home</span>
                                            </a>
                                        </li>
                                        <li
                                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-112"
                                        >
                                            <a href="/app/" class="nav__link">
                                                <span class="nav__title">Our App</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </header>
            <div style="min-height: 100%;">
              <router-view/>
            </div>
            <footer id="footer" class="footer__wrapper fixed-bottom" >
                <div id="colophon" class="colophon">
                    <div class="container">
                        <div class="colophon__row row flex-row justify-content-between">
                            <div class="col-12 col-sm-auto">
                                <div id="footer__credits" class="footer__credits">
                                    <p class="czr-copyright">
                                        <span class="czr-copyright-text">&copy;&nbsp;2020&nbsp;</span>
                                        <a
                                            class="czr-copyright-link"
                                            href="/"
                                            title="Wersa"
                                        ></a>
                                        <span
                                            class="czr-rights-text"
                                        >KIONIER&nbsp;&ndash;&nbsp;All rights reserved</span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-12 col-sm-auto">
                                <div id="footer__credits" class="footer__credits">
                                    <p class="czr-copyright">
                                        <a
                                            class="czr-copyright-link"
                                            href="https://twitter.com/wersa_app"
                                            title="Twitter"
                                        ><img
                                            src="/images/twitter.png"
                                            alt="Twitter"
                                            style="margin-top:-7.5px;margin-bottom:-7.5px"
                                            data-no-retina
                                        /></a>
                                        <a
                                            class="czr-copyright-link"
                                            href="https://www.facebook.com/Wersa-101276155691889"
                                            title="Facebook"
                                        ><img
                                            src="/images/facebook.png"
                                            alt="Facebook"
                                            style="margin-top:-9.5px;margin-bottom:-5.5px"
                                            data-no-retina
                                        /></a>
                                    </p>
                                </div>
                            </div>
                            <div class="col-12 col-sm-auto">
                                <div id="footer__credits" class="footer__credits">
                                    <p class="czr-copyright">
                                        <a
                                            class="czr-copyright-link"
                                            href="/privacy-policy-and-terms-of-use"
                                            title="Privacy Policy and Terms of Use"
                                        >Privacy Policy and Terms of Use</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
        <!-- end #tc-page-wrap -->

        <!-- <section class="czr-overlay search_o">
            <a href="#" class="search-close_btn search-toggle_btn czr-overlay-toggle_btn">
                <i class="icn-close"></i>
            </a>
            <div class="overlay-content">
                <div class="search__wrapper">
                    <div class="search-form__container">
                        <form
                            action="http://wersa.co.za/"
                            method="get"
                            class="czr-form search-form"
                        >
                            <div class="form-group czr-focus">
                                <label for="s-5e2c477a28c64" id="lsearch-5e2c477a28c64">
                                    <span>Search</span>
                                    <i class="icn-search"></i>
                                    <i class="icn-close"></i>
                                </label>
                                <input
                                    id="s-5e2c477a28c64"
                                    class="form-control czr-search-field"
                                    name="s"
                                    type="text"
                                    value
                                    aria-describedby="lsearch-5e2c477a28c64"
                                    title="Search &hellip;"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <div class="btn czr-btt czr-btta right">
            <i class="icn-up-small"></i>
        </div> -->
    </div>
</template>

<style>
a {
   outline: 0 !important;
}
a:hover {
  text-decoration: none !important;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}
/*@import './assets/styles/yourstyles.css';*/
@import '//fonts.googleapis.com/css?family=Source+Sans+Pro';
@import '/css/fontawesome-all.min.css?ver=4.1.39';
@import '/css/style.min.css?ver=5.2.5';
@import '/css/cstyle.min.css?ver=4.1.39'; 



</style>

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BCarousel,BCarouselSlide } from 'bootstrap-vue'
Vue.component('b-carousel', BCarousel)
Vue.component('b-carousel-slide', BCarouselSlide)

<script>
export default {
    data () {
        return {
            showmenu: false
        };
    },
    mounted() {
      let cfScript = document.createElement('script');
      //cfScript.setAttribute('defer');
      cfScript.setAttribute('src', 'https://static.cloudflareinsights.com/beacon.min.js');
      cfScript.setAttribute('data-cf-beacon','{"token": "ed7beb447ce541bcaf7fc35e57f92a74"}');
      document.head.appendChild(cfScript);

      let clickyScriptVar = document.createElement('script');
      clickyScriptVar.innerHTML("var clicky_site_ids = clicky_site_ids || []; clicky_site_ids.push(101291518);var clicky_custom = clicky_custom || {};   clicky_custom.cookies_disable = 1;");
      document.head.appendChild(clickyScriptVar);

      let clickyScript = document.createElement('script');
      clickyScript.setAttribute('async','');
      clickyScript.setAttribute('src','//static.getclicky.com/js');
      document.head.appendChild(clickyScript);

    },
};
</script>
